export default __webpack_public_path__ + "static/media/cgp_intro.0f5d72a9.png";